import React, { Component } from "react";
import { connect } from "react-redux";
import Loading from "../Loading";
import DatePicker from "react-datepicker";
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../config/config";
import { AlertError } from "../Alert/Alert";
import { NumberUtil } from "../../utils/number-util";
import { DateUtil } from "../../utils/dateUtil";
import { FormGroup, Label, Input, Button, Table, Row, Col } from "reactstrap";

class DebtorTrackPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      token: "",
      isLoading: false,
      date_start: new Date(),
      date_end: new Date(),
      payment_status: "pay_received", // Default value
      lists: [],
      branches: [],
      branch_id: "",
      totalAmountToPay: 0,
      totalAmountPaid: 0,
      datePaySortOrder: null, // 'asc', 'desc', or null
      dateDeptSortOrder: null, // 'asc', 'desc', or null
    };

    this.handleDateStart = this.handleDateStart.bind(this);
    this.handleDateEnd = this.handleDateEnd.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.loadBranchData = this.loadBranchData.bind(this);
    this.loadTrackingData = this.loadTrackingData.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
    this.handleSortByDatePay = this.handleSortByDatePay.bind(this);
    this.handleSortByDateDept = this.handleSortByDateDept.bind(this);
  }

  componentWillMount() {
    this.setState({
      user: JSON.parse(this.props.user),
      token: this.props.token,
    });
  }

  componentDidMount() {
    this.loadBranchData();
    // Auto load data with default filters
    this.handleSearch();
  }

  handleDateStart(date) {
    this.setState({
      date_start: date,
    });
  }

  handleDateEnd(date) {
    this.setState({
      date_end: date,
    });
  }

  handleOnChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  loadBranchData() {
    axios
      .get(APIURL + "/branch/", {
        headers: { Authorization: this.state.token },
      })
      .then((res) => {
        this.setState({ branches: res.data });
      })
      .catch((error) => {
        this.setState({ branches: [] });
      });
  }

  loadTrackingData() {
    this.setState({ isLoading: true });

    const { date_start, date_end, payment_status, branch_id } = this.state;

    const data = {
      start_date: moment(date_start).format("YYYY-MM-DD"),
      end_date: moment(date_end).format("YYYY-MM-DD"),
      payment_status: payment_status,
      branch_id: branch_id,
    };

    axios
      .post(APIURL + "/report/debtor_track_payment", data, {
        headers: { Authorization: this.state.token },
      })
      .then((res) => {
        const lists = res.data || [];
        const totalAmountToPay = lists.reduce(
          (sum, item) => sum + parseFloat(item.amount_dept || 0),
          0
        );
        const totalAmountPaid = lists.reduce(
          (sum, item) => sum + parseFloat(item.amount_pay || 0),
          0
        );

        this.setState({
          lists: lists,
          totalAmountToPay: totalAmountToPay,
          totalAmountPaid: totalAmountPaid,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({
          lists: [],
          isLoading: false,
        });
        AlertError("เกิดข้อผิดพลาดในการดึงข้อมูล");
      });
  }

  handleSearch() {
    if (this.state.date_start > this.state.date_end) {
      AlertError("วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด กรุณาตรวจสอบ");
      return;
    }
    this.loadTrackingData();
  }

  exportToExcel() {
    const { date_start, date_end, payment_status, branch_id } = this.state;

    const data = {
      start_date: moment(date_start).format("YYYY-MM-DD"),
      end_date: moment(date_end).format("YYYY-MM-DD"),
      payment_status: payment_status,
      branch_id: branch_id,
    };

    axios
      .post(APIURL + "/report/debtor_track_payment_excel", data, {
        headers: { Authorization: this.state.token },
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `รายงานติดตามการรับชำระเงิน_${moment().format(
            "YYYY-MM-DD_HH-mm-ss"
          )}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Export error:", error);
        AlertError("เกิดข้อผิดพลาดในการส่งออกข้อมูล");
      });
  }

  handleSortByDatePay() {
    const { lists, datePaySortOrder } = this.state;
    let newSortOrder;
    let sortedLists;

    if (datePaySortOrder === null || datePaySortOrder === "desc") {
      // เรียงจากน้อยไปมาก (asc)
      newSortOrder = "asc";
      sortedLists = [...lists].sort((a, b) => {
        const dateA =
          a.date_pay === null ||
          a.date_pay === "0000-00-00" ||
          a.date_pay === undefined
            ? "9999-12-31"
            : a.date_pay;
        const dateB =
          b.date_pay === null ||
          b.date_pay === "0000-00-00" ||
          b.date_pay === undefined
            ? "9999-12-31"
            : b.date_pay;
        return new Date(dateA) - new Date(dateB);
      });
    } else {
      // เรียงจากมากไปน้อย (desc)
      newSortOrder = "desc";
      sortedLists = [...lists].sort((a, b) => {
        const dateA =
          a.date_pay === null ||
          a.date_pay === "0000-00-00" ||
          a.date_pay === undefined
            ? "1970-01-01"
            : a.date_pay;
        const dateB =
          b.date_pay === null ||
          b.date_pay === "0000-00-00" ||
          b.date_pay === undefined
            ? "1970-01-01"
            : b.date_pay;
        return new Date(dateB) - new Date(dateA);
      });
    }

    this.setState({
      lists: sortedLists,
      datePaySortOrder: newSortOrder,
    });
  }

  handleSortByDateDept() {
    const { lists, dateDeptSortOrder } = this.state;
    let newSortOrder;
    let sortedLists;

    if (dateDeptSortOrder === null || dateDeptSortOrder === "desc") {
      // เรียงจากน้อยไปมาก (asc)
      newSortOrder = "asc";
      sortedLists = [...lists].sort((a, b) => {
        const dateA =
          a.date_dept === null ||
          a.date_dept === "0000-00-00" ||
          a.date_dept === undefined
            ? "9999-12-31"
            : a.date_dept;
        const dateB =
          b.date_dept === null ||
          b.date_dept === "0000-00-00" ||
          b.date_dept === undefined
            ? "9999-12-31"
            : b.date_dept;
        return new Date(dateA) - new Date(dateB);
      });
    } else {
      // เรียงจากมากไปน้อย (desc)
      newSortOrder = "desc";
      sortedLists = [...lists].sort((a, b) => {
        const dateA =
          a.date_dept === null ||
          a.date_dept === "0000-00-00" ||
          a.date_dept === undefined
            ? "1970-01-01"
            : a.date_dept;
        const dateB =
          b.date_dept === null ||
          b.date_dept === "0000-00-00" ||
          b.date_dept === undefined
            ? "1970-01-01"
            : b.date_dept;
        return new Date(dateB) - new Date(dateA);
      });
    }

    this.setState({
      lists: sortedLists,
      dateDeptSortOrder: newSortOrder,
    });
  }

  render() {
    const {
      isLoading,
      date_start,
      date_end,
      payment_status,
      lists,
      branches,
      branch_id,
      totalAmountToPay,
      totalAmountPaid,
      datePaySortOrder,
      dateDeptSortOrder,
    } = this.state;

    return (
      <div>
        <div className="card-block">
          <div>
            <div className="card card-accent-primary">
              <div className="card-header">
                <div className="row col-12 mt-1">
                  <div className="col-6">
                    <strong className="text-title">
                      {" "}
                      ติดตามการรับชำระเงิน
                    </strong>
                  </div>
                </div>
              </div>

              <div className="card-block" style={styles.overflowY}>
                <div className="row mt-1">
                  <div className="mt-2 ml-4">วันที่เริ่มต้น</div>
                  <div className="form-group col-2 ml-2">
                    <DatePicker
                      selected={date_start}
                      onChange={this.handleDateStart}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      placeholderText="วันที่เริ่มต้น"
                    />
                  </div>

                  <div className="form-group col-2">
                    <DatePicker
                      selected={date_end}
                      onChange={this.handleDateEnd}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      placeholderText="วันที่สิ้นสุด"
                    />
                  </div>

                  <div className="form-group col-2">
                    <Input
                      type="select"
                      name="branch_id"
                      value={branch_id}
                      onChange={this.handleOnChange}
                    >
                      <option value="">ทุกสาขา</option>
                      {branches.map((branch) => (
                        <option key={branch.branch_id} value={branch.branch_id}>
                          {branch.branch_name}
                        </option>
                      ))}
                    </Input>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="form-group mt-1 ml-3">
                    <input
                      type="radio"
                      name="payment_status"
                      value="pay_not_yet"
                      className="btn btn-primary"
                      checked={payment_status === "pay_not_yet"}
                      onChange={this.handleOnChange}
                    />{" "}
                    &nbsp;<span style={{ marginTop: -4 }}>ยังไม่ชำระ</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input
                      type="radio"
                      name="payment_status"
                      value="pay_received"
                      className="btn btn-primary"
                      checked={payment_status === "pay_received"}
                      onChange={this.handleOnChange}
                    />{" "}
                    &nbsp;<span style={{ marginTop: -4 }}>ชำระแล้ว</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <input
                      type="radio"
                      name="payment_status"
                      value="all_payment"
                      className="btn btn-primary"
                      checked={payment_status === "all_payment"}
                      onChange={this.handleOnChange}
                    />{" "}
                    &nbsp;<span style={{ marginTop: -4 }}>ทั้งหมด</span>
                  </div>

                  <div className="form-inline col-3 text-right ml-5">
                    <button
                      type="button"
                      style={{ width: 80, marginRight: 8, marginTop: -14 }}
                      className="btn btn-sm btn-primary"
                      onClick={this.handleSearch}
                    >
                      {" "}
                      ตกลง{" "}
                    </button>
                    {lists.length > 0 && (
                      <button
                        type="button"
                        style={{ width: 80, marginTop: -14 }}
                        className="btn btn-sm btn-success"
                        onClick={this.exportToExcel}
                      >
                        {" "}
                        Excel{" "}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mt-1 ml-3" style={{ font: 14 }}>
                  <span>ยังไม่ชำระ ข้อมูลตามวันครบกำหนดชำระ</span>
                  <br />
                  <span>ชำระแล้ว ข้อมูลตามวันที่รับชำระจริง</span>
                </div>

                <br />

                {isLoading ? (
                  <Loading />
                ) : (
                  <div>
                    {lists.length > 0 ? (
                      <div>
                        <p className="text-muted pl-3">
                          แสดงข้อมูล {lists.length} รายการ
                        </p>
                        <Table striped responsive hover>
                          <thead>
                            <tr>
                              <th className="text-center text-nowrap">ลำดับ</th>
                              <th className="text-center text-nowrap">
                                ชื่อลูกหนี้
                              </th>
                              <th className="text-center text-nowrap">
                                เบอร์โทร
                              </th>
                              <th className="text-center text-nowrap">
                                ประเภทหนี้
                              </th>
                              <th className="text-center text-nowrap">
                                ทะเบียนรถ
                              </th>
                              <th className="text-center text-nowrap">
                                วันครบกำหนดชำระ
                                <i
                                  className={`icons ml-1 ${
                                    dateDeptSortOrder === "asc"
                                      ? "icon-arrow-up"
                                      : "icon-arrow-down"
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "0.8em",
                                    opacity: dateDeptSortOrder ? 1 : 0.3,
                                  }}
                                  onClick={this.handleSortByDateDept}
                                ></i>
                              </th>
                              <th className="text-center text-nowrap">
                                วันที่ชำระจริง
                                <i
                                  className={`icons ml-1 ${
                                    datePaySortOrder === "asc"
                                      ? "icon-arrow-up"
                                      : "icon-arrow-down"
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "0.8em",
                                    opacity: datePaySortOrder ? 1 : 0.3,
                                  }}
                                  onClick={this.handleSortByDatePay}
                                ></i>
                              </th>
                              <th className="text-center text-nowrap">
                                จำนวนเงินที่ต้องชำระ
                              </th>
                              <th className="text-center text-nowrap">
                                จำนวนเงินที่รับชำระ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists.map((item, index) => (
                              <tr key={item.debtors_detail_id || index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-left text-nowrap">
                                  {item.customer_name} &nbsp;{" "}
                                  {item.customer_lastname}
                                </td>
                                <td className="text-left">
                                  {item.customer_mobile}
                                </td>

                                <td className="text-left">
                                  {item.debtors_name}
                                </td>
                                <td className="text-left text-nowrap">
                                  {item.car_id && item.car_sell_id && (
                                    <>
                                      {(() => {
                                        const licensePlate =
                                          item.car_license_plate_new &&
                                          item.province_name_new
                                            ? `${item.car_license_plate_new} ${item.province_name_new}`
                                            : item.car_license_plate_old &&
                                              item.province_name_old
                                            ? `${item.car_license_plate_old} ${item.province_name_old}`
                                            : "";
                                        return licensePlate ? (
                                          <>
                                            <span>{licensePlate}</span>
                                          </>
                                        ) : null;
                                      })()}
                                    </>
                                  )}
                                </td>
                                <td className="text-left text-nowrap">
                                  {DateUtil.convertLongDateThaiNew(
                                    item.date_dept
                                  )}
                                </td>
                                <td className="text-left text-nowrap">
                                  {payment_status === "pay_received" ||
                                  payment_status === "all_payment"
                                    ? item.date_pay === "0000-00-00" ||
                                      item.date_pay === null ||
                                      item.date_pay === undefined
                                      ? "-"
                                      : DateUtil.convertLongDateThaiNew(
                                          item.date_pay
                                        )
                                    : "-"}
                                </td>
                                <td className="text-right">
                                  {NumberUtil.addCommas(item.amount_dept)}
                                </td>
                                <td className="text-right">
                                  {payment_status === "pay_received" ||
                                  payment_status === "all_payment"
                                    ? item.amount_pay > 0
                                      ? NumberUtil.addCommas(item.amount_pay)
                                      : "-"
                                    : "-"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr className="font-weight-bold">
                              <td colSpan="5" className="text-right">
                                รวมทั้งหมด
                              </td>
                              <td className="text-right">
                                {NumberUtil.addCommas(totalAmountToPay)}
                              </td>
                              <td className="text-right">
                                {payment_status === "pay_received" ||
                                payment_status === "all_payment"
                                  ? NumberUtil.addCommas(totalAmountPaid)
                                  : "-"}
                              </td>
                            </tr>
                          </tfoot>
                        </Table>
                      </div>
                    ) : (
                      <div className="text-center p-4">
                        <p>ไม่พบข้อมูล</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  overflowY: {
    overflow: "scroll",
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  type: state.auth.type,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(DebtorTrackPayment);
